import { Button, DebouncedInput, SidebarHeader, SidebarTrigger, Stack } from "@altimateai/lego";
import { IconSearch } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { AddIcon, RobotIcon } from "@/assets/icons";
import ViewAllSchedulesButton from "./ViewAllSchedulesButton";

interface PlaygroundSidebarHeaderProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  onNewChat: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const PlaygroundSidebarHeader = ({
  searchText,
  onSearchChange,
  onNewChat,
}: PlaygroundSidebarHeaderProps) => {
  return (
    <SidebarHeader>
      <Stack align="center" justify="between" className="al-mb-4">
        <Stack align="center">
          <RobotIcon className="al-w-8 al-h-8 al-rounded-lg" />
          <span className="al-text-lg al-font-semibold">Studio</span>
        </Stack>
        <SidebarTrigger />
      </Stack>

      <Stack direction="column" gap="2xl">
        <Button asChild className="al-w-full" size="sm" variant="secondary">
          <Link to="/studio" onClick={onNewChat}>
            <AddIcon className="al-w-4 al-h-4 al-mr-2" />
            New Chat
          </Link>
        </Button>

        <Stack direction="row" align="center" gap="sm" className="al-w-full">
          <div className="al-flex-1 al-min-w-0">
            <DebouncedInput
              type="search"
              placeholder="Search"
              value={searchText}
              onChange={onSearchChange}
              debounceMs={300}
              icon={IconSearch}
              iconPosition="left"
            />
          </div>
          <ViewAllSchedulesButton />
        </Stack>
      </Stack>
    </SidebarHeader>
  );
};
